import React from 'react';
import { Check } from 'lucide-react';
import { siteConfig } from '../config/siteConfig';
import { LeadForm } from '../components/LeadForm';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative w-full bg-brand-navy pt-32 pb-24 md:pt-44 md:pb-40 overflow-hidden" data-id="element-183">
      {/* Ambient Glows */}
      <div className="absolute top-0 left-0 w-[600px] h-[600px] bg-brand-gold/10 rounded-full blur-[120px] -translate-x-1/2 -translate-y-1/2 pointer-events-none" data-id="element-184"></div>
      <div className="absolute bottom-0 right-0 w-[600px] h-[600px] bg-brand-gold/8 rounded-full blur-[120px] translate-x-1/3 translate-y-1/3 pointer-events-none" data-id="element-185"></div>

      {/* Noise Texture */}
      <div className="absolute inset-0 bg-noise opacity-[0.03] pointer-events-none mix-blend-overlay" data-id="element-186"></div>

      <div className="container mx-auto px-4 md:px-8 max-w-7xl relative z-10" data-id="element-187">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-start" data-id="element-188">
          {/* Left Column - Copy */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="w-full lg:w-[60%] flex flex-col pt-4" data-id="element-189">
            <div className="mb-8 w-fit" data-id="element-190">
              <span className="border border-brand-gold text-brand-gold text-[11px] md:text-xs font-bold tracking-wider md:tracking-widest uppercase px-3 md:px-4 py-1.5 md:py-2 rounded-full whitespace-nowrap inline-block" data-id="element-191">
                <span className="md:hidden" data-id="element-192">FOR MED SPAS SPENDING $5K+/MO</span>
                <span className="hidden md:inline" data-id="element-193">
                  {siteConfig.hero.eyebrow}
                </span>
              </span>
            </div>

            <h1 className="font-serif text-[40px] leading-[1.1] md:text-[64px] font-medium text-white mb-6 tracking-tight" data-id="element-194">
              {siteConfig.hero.headline}
            </h1>

            <p className="text-lg md:text-xl text-gray-300 mb-10 leading-relaxed max-w-2xl font-light" data-id="element-195">
              {siteConfig.hero.subheadline}
            </p>

            <ul className="space-y-5 mb-12" data-id="element-196">
              {siteConfig.hero.bullets.map((bullet, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-197">
                  <div className="mt-1 flex-shrink-0 w-6 h-6 rounded-full bg-brand-gold/20 flex items-center justify-center border border-brand-gold/30" data-id="element-198">
                    <Check className="w-4 h-4 text-brand-gold" data-id="element-199" />
                  </div>
                  <span className="text-base md:text-lg text-white font-medium leading-snug" data-id="element-200">
                    {bullet}
                  </span>
                </li>)}
            </ul>

            <div className="pt-8 border-t border-white/10" data-id="element-201">
              <p className="text-sm text-gray-400 font-medium tracking-wide" data-id="element-202">
                {siteConfig.hero.trustLine}
              </p>
            </div>
          </motion.div>

          {/* Right Column - Form */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="w-full lg:w-[40%] relative" data-id="element-203">
            <LeadForm variant="dark" data-id="element-204" />
          </motion.div>
        </div>
      </div>
    </section>;
}